module.exports = __webpack_public_path__ + "media/file-icons/image-d56a2d2a.gif";